module.exports = __webpack_public_path__ + "media/images/emoticons/rain-30811c07986d81a662cc1c7d031affdf.gif";